{
  "css": {
    "breakpoint": {
      "tablet": 1355,
      "medium": 1024,
      "mobile": 800
    },
    "inputField": {
      "height": "3em"
    }
  }
}
